'use strict';

module.exports = Odigeo.View.extend({

    template: {
        main: '#ancillaries_debuginfo_script',
    },

    selectors: {
        mainContainer: '.main_container',
    },

    renderTemplate: function(model) {
        this.$cachedSelectors.mainContainer.html(this.template.main(model.toJSON()));
    },

    init: function() {
        this.template = Odigeo.Utils.getTemplates(this.$el, this.template, {variable: 'tmpl'});
        this.listenTo(this.model, 'change', this.renderTemplate);
    },
});
